/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseMenuItemFragment} from '@amblique/contentful/app/contentful/fragments/menu-item/base-menu-item.fragment';
import {ImageFragment} from '@amblique/contentful/app/contentful/fragments/image/image.fragment';
import {LinkFragment} from '@amblique/contentful/app/contentful/fragments/link/link.fragment';
import {NavigationColumnFragment} from '@amblique/contentful/app/contentful/fragments/navigation-column/navigation-column.fragment';

export const FullMenuItemFragment = gql`
  ${BaseMenuItemFragment}
  ${ImageFragment}
  ${LinkFragment}
  ${NavigationColumnFragment}

  fragment FullMenuItemFragment on MenuItem {
    ...BaseMenuItemFragment

    featuredLink {
      ...LinkFragment
    }
    imagesCollection {
      items {
        __typename
        ... on Image {
          ...ImageFragment
        }
      }
    }
    imagesCursorCollection {
      items {
        __typename
        ... on Image {
          ...ImageFragment
        }
      }
    }
    link {
      ...LinkFragment
    }
    submenuCollection {
      items {
        __typename
        ... on NavigationColumn {
          ...NavigationColumnFragment
        }
      }
    }
    submenuCursorCollection {
      items {
        __typename
        ... on NavigationColumn {
          ...NavigationColumnFragment
        }
      }
    }
  }
`;
